<script lang="ts">
  import { onMount, getContext } from 'svelte'
  import ChevronRight from './ChevronRight.svelte'

  import type { Writable } from 'svelte/store'

  export let item = {}
  export let pathChunks: string[]
  export let showKids = false
  export let depthStore

  const menuNavHistory: Writable<{key: string, items: any[]}[]> = getContext('menuNavHistory')
  const backItemTitle = getContext('backItemTitle')
  const backLeadingIconString = getContext('backLeadingIconString')
  const isPolarityReversed = getContext('isPolarityReversed')



  const childHandler = (e)=> {
    e.preventDefault()
    backItemTitle.set(item.Title)
    // activeItemMenu.set(item.ChildNodes)
    // activeItemKey.set(item.Url)
    menuNavHistory.set([...$menuNavHistory, {key: item.Url, items: item.ChildNodes, previousTitle: item.Title}])
  }

  /**
   * By default, we provide a no-op onClick function that can optionally be replaced.
   * 
   * @type {function|false}
   */
  let clickOverride = ()=> false

  $: hasKids = item.ChildNodes && item.ChildNodes.length > 1

  onMount(()=> {
    if(hasKids && typeof clickOverride === 'function' && clickOverride() === false) {
      clickOverride = childHandler
    }
  })
</script>

<li
  class:has_kids={hasKids}
  class:active-trail={showKids}
  class:url-in-path={$pathChunks[$depthStore]?.includes(item?.Url?.substring(1).split('/').findLast(()=> true))}
  class="depth-{$depthStore}"
  >
  <a href="{item.Url}" on:click={clickOverride}>
    <span class="title grow">{item.Title}</span>
    {#if hasKids }
      <span class="icon">
        <ChevronRight />
      </span>
    {/if}
  </a>
</li>

<style lang="scss">
  li {
    a {
      span.title {
        flex-grow: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      span.icon {
        width: 3rem;
      }
    }
  }
</style>